import React from "react"
import { SectionWrapper } from "../../components/common/wrappers/Wrappers"
import styled from "styled-components"
import { SectionTitle } from "../../components/common/typography/Typography"
import { breakpoint } from "../../configs/utilities"
import AwardShareButton from "../../components/awards/AwardShareButton"

const ServicesSection = ({ awards, mover }) => {
  const generateLink = award => {
    const isStateAward = !award.city

    return isStateAward
      ? `${process.env.GATSBY_BASE_URL}/states/${award.state.slug}/`
      : `${process.env.GATSBY_BASE_URL}/movers/${award.state.slug}/${award.city.slug}/`
  }

  return (
    <Wrapper>
      <SectionWrapper>
        <SectionTitle>Awards</SectionTitle>
        <AwardsWrapper>
          {awards.slice(0, 4).map((item, index) => {
            return (
              <Award key={index}>
                <a
                  href={generateLink(item)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <AwardImage
                    alt={item.id}
                    src={item.publicImageUrl}
                    width={280}
                  />
                </a>
                <AwardShareButton award={item} mover={mover} />
              </Award>
            )
          })}
        </AwardsWrapper>
      </SectionWrapper>
    </Wrapper>
  )
}

export default ServicesSection

const Wrapper = styled.div``

const AwardsWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  column-gap: 30px;
  row-gap: 30px;
`

const Award = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const AwardImage = styled.img`
  width: 100%;
  padding: 0 10px;
  max-width: 220px;

  @media screen and (min-width: ${breakpoint.lg}) {
    max-width: 250px;
  }
`
